import { useSelector } from 'react-redux';
import { SuspensionBannersContextProvider, ContextSuspensionBanners
// @ts-expect-error not typed
} from 'ui-suspension-banners-lib';
// @ts-expect-error not typed
import { getHasApprovalsWriteAccess } from '../redux/selectors/authSelectors';
// @ts-expect-error not typed
import { getHasApprovalsReadAccess } from '../redux/selectors/authSelectors';
import { getContentModelName, getContentModelId
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not typed
import EditorApprovalProvider from 'ContentEditorUI/components/approvals/EditorApprovalProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExtraApplicationContainerEditorWrapper = ({
  children
}) => {
  const approvalContentId = useSelector(getContentModelId);
  const approvalAssetName = useSelector(getContentModelName);
  const hasReadAccessToProductApprovals = useSelector(getHasApprovalsReadAccess);
  const hasWriteAccessToProductApprovals = useSelector(getHasApprovalsWriteAccess);
  return /*#__PURE__*/_jsx(EditorApprovalProvider, {
    approvalType: "BLOG_POST",
    restartOnConclude: true,
    hasReadAccessToProductApprovals: hasReadAccessToProductApprovals,
    hasWriteAccessToProductApprovals: hasWriteAccessToProductApprovals,
    contentId: approvalContentId,
    assetName: approvalAssetName,
    children: /*#__PURE__*/_jsxs(SuspensionBannersContextProvider, {
      children: [/*#__PURE__*/_jsx(ContextSuspensionBanners, {
        scope: "landingpages-trusted",
        source: "BLOG_POSTS"
      }), children]
    })
  });
};
export default ExtraApplicationContainerEditorWrapper;